<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ member.name }}</h3>
        <datepicker-component
            @onDateSelected="onDateSelected"
        />
      </div>

      <timesheet-overview-component :overview="overview"/>

      <div class="d-flex">
        <div class="col col-md-6 pl-0 pr-2">
          <timesheet-payroll-component :payroll="payroll" />
        </div>
        <div class="col col-md-6 pr-0 pl-2">
          <timesheet-job-codes-component :job-codes="jobCodes" />
        </div>
      </div>
    </div>
    <div class="centered-column">
      <div class="white-card">
          <div class="white-card-header">
              <div class="title-wrap">
                <label class="title-label">
                  {{label.get('timesheets')}}
                </label>
              <!--  <i class="atto info-icon" id="tooltip-timesheets"></i>
                <b-tooltip
                    target="tooltip-timesheets"
                    custom-class="info-tooltip"
                    placement="bottom">
                  <label>Timesheets</label>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                    dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
                </b-tooltip>-->
              </div>
              <div>
                    <timesheet-tools-component
                        :member="member"
                        :download="true"
                        :can-manage-entries="canManageEntries"
                        :show-download-license="memberLicense.license && memberLicense.license.path"
                    />
              </div>
          </div>
        <div
            class="content-list"
            :class="{'b-loaded': loading}"
        >
          <div
              v-if="loading"
              class="timesheet-overlay gray-timesheet-overlay"
          >
            <span class="loading-spinner" />
          </div>
          <div class="column-header table-header">
            <span class="first-column">
              <span class="column-header date">{{label.get('date')}}</span>
              <span
                  v-if="entry_type === 'WEEKS' || entry_type === 'MONTHS'"
                  class="column-header name"
              >{{label.get('time_period')}}
              </span>
              <span
                  v-if="entry_type === 'DAYS' || entry_type === 'WEEKS_AND_DAYS'"
                  class="column-header name"
                  :class="{'am-pm': isAmPm}"
              >{{label.get('clock_in')}} <i class="atto atto-rdir-arrow-b" /> {{label.get('clock_out')}}
              </span>
            </span>
            <span class="second-column">
               <span class="column-header regular">{{label.get('regular')}}</span>
              <span v-if="isVisibleOvertime" class="column-header overtime">{{ label.get('overtime') }}</span>
              <span v-if="isVisibleDoubleOvertime" class="column-header double_ot">{{ label.get('double_ot')}}</span>
              <span class="column-header unpaid_break">{{ label.get('unpaid_break') }}</span>
              <span class="column-header paid_break">{{ label.get('paid_break') }}</span>
              <span class="column-header time_off">{{ label.get('time_off') }}</span>
              <span class="column-header paid_time_off">{{ label.get('paid_time_off') }}</span>
              <span class="column-header total">{{label.get('total')}}</span>
              <span class="column-header est-pay">{{ label.get('est_pay') }}</span>
            </span>

          </div>
          <div class="table-content"
               :class="{'archived-member':  member.deleted}">
            <ul
                v-if="entry_type === 'DAYS'"
                class="logs-list days"
            >
              <li
                  v-for="(item, idx) in entries"
                  :key="idx"
                  :class="{'no-entry': !item.entry}"
              >
                <div
                    v-if="!item.entry"
                    class="no-entries"
                    @click="addNewTimeEntry(item)"
                >
                  <div class="day-log">
                    <div class="calendar-icon">
                    <span class="day">
                      {{ item.weekday.name }}
                    </span>
                      <span class="date">
                      {{ item.weekday.day }}
                    </span>
                    </div>
                    <div class="time-interval">
                      <span class="not-active" :class="{'can-add': canManageEntries}">{{label.get('not_active')}}</span>
                      <span class="add-new-entry" v-if="canManageEntries">
                        <i class="atto atto-add-more-circled" />
                        {{label.get('add_new_entry')}}
                      </span>
                    </div>
                  </div>
                  <div class="hour-total">
                    <span class="hours regular">·</span>
                    <span v-if="isVisibleOvertime" class="hours overtime">·</span>
                    <span v-if="isVisibleDoubleOvertime" class="hours double_ot">·</span>
                    <span class="hours unpaid_break">·</span>
                    <span class="hours paid_break">·</span>
                    <span class="hours time_off">·</span>
                    <span class="hours paid_time_off">·</span>
                    <span class="hours total">·</span>
                    <span class="hours est-pay">·</span>
                  </div>

                  <!--<a
                      v-if="canManageEntries"
                      href="javascript:void(0)"
                      class="add-weekend-entry"
                  >
                    <i class="atto atto-add-more" />
                  </a>-->
                </div>
                <div
                    v-if="item.entry"
                    class="has-entries"
                >
                  <router-link
                      :to="getRouteUrl(item)"
                  >
                    <div class="day-log">
                      <div class="calendar-icon">
                      <span class="day">
                        {{ item.weekday.name }}
                      </span>
                        <span class="date">
                        {{ item.weekday.day }}
                      </span>
                      </div>
                      <div
                          v-if="!item.entry.time_off"
                          class="time-interval"
                          :class="{'am-pm': isAmPm}"
                      >
                        <span class="start-time"> {{ item.entry.start }} </span>
                        <i class="atto atto-rdir-arrow-b" />
                        <span class="end-time">{{ item.entry.end }}</span>
                      </div>

                      <div
                          v-if="item.entry.time_off"
                          class="time-interval"
                      >
                        <span class="pto">{{ item.entry.time_off }}</span>
                      </div>

                      <!--<a href="javascript:void(0)"
                                                                 class="map-logs"
                                                                 @click="showEntryLogs($event)">
                                                                  <i class="atto atto-view-map"></i>
                                                              </a>-->
                      <!--<span class="break-line"></span>-->
                      <div
                          v-if="item.entry.manual && item.entry.time_off === null"
                          class="manual-entries-wrapper"
                      >
                        <i class="manual-entry icon" />
                      </div>
                    </div>
                    <div
                        v-if="!item.entry.time_off"
                        class="hour-total"
                    >
                      <span class="hours regular">{{ item.entry.regular_hours }}</span>
                      <span v-if="isVisibleOvertime" class="hours overtime">{{ item.entry.overtime }}</span>
                      <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{ item.entry.double_overtime }}</span>
                      <span class="hours unpaid_break">{{ item.entry.unpaid_break }}</span>
                      <span class="hours paid_break">{{ item.entry.paid_break }}</span>
                      <span class="hours time_off">{{ item.entry.unpaid_time_off }}</span>
                      <span class="hours paid_time_off">{{ item.entry.paid_time_off }}</span>
                      <span class="hours total_hours">{{ item.entry.total_hours }}</span>
                      <span class="hours est-pay">{{ item.entry.est_total_pay }}</span>
                    </div>
                    <div
                        v-if="item.entry.time_off"
                        class="hour-total"
                    >
                      <span class="hours regular">·</span>
                      <span v-if="isVisibleOvertime" class="hours overtime">·</span>
                      <span v-if="isVisibleDoubleOvertime" class="hours double_ot">·</span>
                      <span class="hours unpaid_break">·</span>
                      <span class="hours paid_break">·</span>
                      <span class="hours time_off">{{ item.entry.unpaid_time_off }}</span>
                      <span class="hours paid_time_off">{{ item.entry.paid_time_off }}</span>
                      <span class="hours total_hours">{{ item.entry.total_hours }}</span>
                      <span class="hours est-pay">{{ item.entry.est_total_pay }}</span>
                    </div>
                    <div
                        v-if="item.entry.status===1 && canManageEntries"
                        class="customize-log"
                    >
                      <button
                          v-if="canManageEntries && item.entry.id && !item.entry.grouped"
                          class="edit-log"
                          @click="editEntry($event, item)"
                          v-b-tooltip.hover.top="{ customClass: 'edit-tooltip' }" title="Edit"
                      >
                        <i class="atto atto-edit-btn" />
                      </button>
                      <button
                          v-if="canManageEntries && item.entry.id && !item.entry.grouped"
                          class="delete-log"
                          @click="deleteEntry($event, item)"
                          v-b-tooltip.hover="{ customClass: 'delete-tooltip', placement: 'top'}" title="Delete"
                      >
                        <i class="atto atto-delete" />
                      </button>
                    </div>
                   <!-- <div class="arrow">
                      <i class="atto atto-r-arrow-b" />
                    </div>-->
                  </router-link>
                </div>
              </li>
            </ul>

            <ul
                v-else-if="entry_type === 'WEEKS_AND_DAYS'"
                class="day-and-weeks"
            >
              <li
                  v-for="(item, idx) in entries"
                  :key="idx"
                  class="week-wrapper"
              >
                <div class="week-heading">
                  <span class="first-column">
                    <span class="week-label">{{ item.name }}</span>
                    <span class="date-interval">{{ item.date }}</span>
                  </span>
                  <div class="hour-total">
                    <span class="hours regular">{{ item.regular_hours }}</span>
                    <span v-if="isVisibleOvertime" class="hours overtime">{{ item.overtime }}</span>
                    <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{item.double_overtime}}</span>
                    <span class="hours unpaid_break">{{item.unpaid_break}}</span>
                    <span class="hours paid_break">{{item.paid_break}}</span>
                    <span class="hours time_off">{{item.unpaid_time_off}}</span>
                    <span class="hours paid_time_off">{{item.paid_time_off}}</span>
                    <span class="hours total">{{ item.total_hours }}</span>
                    <span class="hours est-pay">{{item.est_total_pay}}</span>
                  </div>
                </div>
                <ul class="days-log">
                  <li
                      v-for="(wItem, wIdx) in item.week_days"
                      :key="wIdx"
                      :class="{'no-entry': !wItem.entry}"
                  >
                    <div
                        v-if="!wItem.entry"
                        class="no-entries"
                        @click="addNewTimeEntry(wItem)"
                    >
                      <div class="day-log">
                        <div class="calendar-icon">
                        <span class="day">
                          {{ wItem.weekday.name }}
                        </span>
                          <span class="date">
                          {{ wItem.weekday.day }}
                        </span>
                        </div>
                        <div class="time-interval">
                          <span class="not-active" :class="{'can-add': canManageEntries}">{{label.get('not_active')}}</span>
                          <span class="add-new-entry" v-if="canManageEntries">
                            <i class="atto atto-add-more-circled" />
                            {{label.get('add_new_entry')}}
                          </span>
                        </div>
                      </div>
                      <div class="hour-total">
                        <span class="hours regular">·</span>
                        <span v-if="isVisibleOvertime" class="hours overtime">·</span>
                        <span v-if="isVisibleDoubleOvertime" class="hours double_ot">·</span>
                        <span class="hours unpaid_break">·</span>
                        <span class="hours paid_break">·</span>
                        <span class="hours time_off">·</span>
                        <span class="hours paid_time_off">·</span>
                        <span class="hours total">·</span>
                        <span class="hours est-pay">·</span>
                      </div>
                     <!-- <a
                          v-if="canManageEntries"
                          href="javascript:void(0)"
                          class="add-weekend-entry"
                      >
                        <i class="atto atto-add-more" />
                      </a>-->
                    </div>
                    <div
                        v-if="wItem.entry"
                        class="has-entries"
                    >
                      <router-link
                          :to="getRouteUrl(wItem)"
                      >
                        <div class="day-log">
                          <div class="calendar-icon">
                          <span class="day">
                            {{ wItem.weekday.name }}
                          </span>
                            <span class="date">
                            {{ wItem.weekday.day }}
                          </span>
                          </div>
                          <div
                              v-if="!wItem.entry.time_off"
                              class="time-interval"
                              :class="{'am-pm': isAmPm}"
                          >
                            <span class="start-time">{{ wItem.entry.start }}</span>
                            <i class="atto atto-rdir-arrow-b" />
                            <span class="end-time">{{ wItem.entry.end }}</span>
                          </div>
                          <div
                              v-if="wItem.entry.time_off"
                              class="time-interval"
                          >
                            <span class="pto">{{ wItem.entry.time_off }}</span>
                          </div>
                          <!--<a href="#"
                                                                             class="map-logs"
                                                                             @click="showEntryLogs($event)">
                                                                              <i class="atto atto-view-map"></i>
                                                                          </a>-->
                          <!--<span class="break-line"></span>-->
                          <div
                              v-if="wItem.entry.manual && wItem.entry.time_off === null"
                              class="manual-entries-wrapper"
                          >
                            <i class="manual-entry icon" />
                          </div>
                        </div>
                        <div
                            v-if="!wItem.entry.time_off"
                            class="hour-total"
                        >
                          <span class="hours regular">{{ wItem.entry.regular_hours }}</span>
                          <span v-if="isVisibleOvertime" class="hours overtime">{{ wItem.entry.overtime }}</span>
                          <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{wItem.entry.double_overtime}}</span>
                          <span class="hours unpaid_break">{{wItem.entry.unpaid_break}}</span>
                          <span class="hours paid_break">{{wItem.entry.paid_break}}</span>
                          <span class="hours time_off">{{wItem.entry.unpaid_time_off}}</span>
                          <span class="hours paid_time_off">{{wItem.entry.paid_time_off}}</span>
                          <span class="hours total">{{ wItem.entry.total_hours }}</span>
                          <span class="hours est-pay">{{wItem.entry.est_total_pay}}</span>
                        </div>

                        <div
                            v-if="wItem.entry.time_off"
                            class="hour-total"
                        >
                          <span class="hours regular">·</span>
                          <span v-if="isVisibleOvertime" class="hours overtime">·</span>
                          <span v-if="isVisibleDoubleOvertime" class="hours double_ot">·</span>
                          <span class="hours unpaid_break">·</span>
                          <span class="hours paid_break">·</span>
                          <span class="hours time_off">{{wItem.entry.unpaid_time_off}}</span>
                          <span class="hours paid_time_off">{{wItem.entry.paid_time_off}}</span>
                          <span class="hours total">{{ wItem.entry.total_hours }}</span>
                          <span class="hours est-pay">{{wItem.entry.est_total_pay}}</span>
                        </div>
                        <div
                            v-if="wItem.entry.status===1 && canManageEntries && wItem.entry.id && !wItem.entry.grouped"
                            class="customize-log"
                        >
                          <button
                              class="edit-log"
                              @click="editEntry($event, wItem)"
                              v-b-tooltip.hover.top="{ customClass: 'edit-tooltip' }" title="Edit"
                          >
                            <i class="atto atto-edit-btn" />
                          </button>
                          <button
                              class="delete-log"
                              @click="deleteEntry($event, wItem)"
                              v-b-tooltip.hover="{ customClass: 'delete-tooltip', placement: 'top' }" title="Delete"
                          >
                            <i class="atto atto-delete" />
                          </button>
                        </div>
                       <!-- <div class="arrow">
                          <i class="atto atto-r-arrow-b" />
                        </div>-->
                      </router-link>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>

            <ul
                v-else-if="entry_type === 'WEEKS'"
                class="logs-list weeks"
            >
              <li
                  v-for="(item, idx) in entries"
                  :key="idx"
                  @click="onPeriodEntryClick(item.period_from, item.period_to)"
              >
                <span class="first-column">
                  <span class="week-label">{{ item.name }}</span>
                  <span class="date-interval">{{ item.date }}</span>
                </span>

                <div class="hour-total">
                  <span class="hours regular">{{ item.regular_hours }}</span>
                  <span v-if="isVisibleOvertime" class="hours overtime">{{ item.overtime }}</span>
                  <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{item.double_overtime}}</span>
                  <span class="hours unpaid_break">{{item.unpaid_break}}</span>
                  <span class="hours paid_break">{{item.paid_break}}</span>
                  <span class="hours time_off">{{item.unpaid_time_off}}</span>
                  <span class="hours paid_time_off">{{item.paid_time_off}}</span>
                  <span class="hours total">{{ item.total_hours }}</span>
                  <span class="hours est-pay">{{item.est_total_pay}}</span>
                </div>
                <!--<div class="arrow">
                  <i class="atto atto-r-arrow-b" />
                </div>-->
              </li>
            </ul>

            <ul
                v-else-if="entry_type === 'MONTHS'"
                class="logs-list weeks"
            >
              <li
                  v-for="(item, idx) in entries"
                  :key="idx"
                  @click="onPeriodEntryClick(item.period_from, item.period_to)"
              >
                <span class="first-column">
                  <span class="week-label">{{ item.name }}</span>
                <span class="date-interval">{{ item.date }}</span>
                </span>
                <div class="hour-total">
                  <span class="hours regular">{{ item.regular_hours }}</span>
                  <span v-if="isVisibleOvertime" class="hours overtime">{{ item.overtime }}</span>
                  <span v-if="isVisibleDoubleOvertime" class="hours double_ot">{{item.double_overtime}}</span>
                  <span class="hours unpaid_break">{{item.unpaid_break}}</span>
                  <span class="hours paid_break">{{item.paid_break}}</span>
                  <span class="hours time_off">{{item.unpaid_time_off}}</span>
                  <span class="hours paid_time_off">{{item.paid_time_off}}</span>
                  <span class="hours total">{{ item.total_hours }}</span>
                  <span class="hours est-pay">{{item.est_total_pay}}</span>
                </div>
               <!-- <div class="arrow">
                  <i class="atto atto-r-arrow-b" />
                </div>-->
              </li>
            </ul>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
    import TimesheetService from "../shared/TimesheetService";
    import TimesheetToolsComponent from '../components/TimesheetToolsComponent';
    import DatepickerComponent from "../components/DatepickerComponent";
    import TimesheetEditor from "../components/TimesheetEditorComponent";
    import SelectDropdownComponent from '../../../shared/components/SelectDropdownComponent';
    import TimesheetOverviewComponent from "../shared/components/TimesheetOverviewComponent";
    import TimesheetPayrollComponent from "../shared/components/TimesheetPayrollComponent";
    import TimesheetJobCodesComponent from "../shared/components/TimesheetJobCodesComponent";

    export default {
        name: "MemberTimesheetsComponent",
        components: {
            TimesheetToolsComponent,
            //ManualEntryComponent,
            TimesheetEditor,
            SelectDropdownComponent,
            DatepickerComponent,
            //EntryLogsPopoverComponent
            TimesheetOverviewComponent,
            TimesheetPayrollComponent,
            TimesheetJobCodesComponent
        },
        data() {
            return {
                range: '',
                period: '',
                popoverShow: false,
                entry: false,
                member: {
                    id: null,
                    uid: '',
                    name: '',
                    deleted: false
                },
                overview: [],
                payroll: null,
                jobCodes: [],
                entries: [],
                entry_type: 'DAYS',
                canManageEntries: false,
                timesheetsEditor: false,
                isLoading: false,
                jobSites : [],
                jobSiteId : '',
                memberLicense: {enabled: false, license: null},
                showArchivedMembers : this.$store.state.showArchivedMembers
            }
        },
        computed: {
          isAmPm() {
              return this.$store.state.userSettings.is_am_pm_time_format;
          },
          loading() {
              return this.isLoading;
          },
          showJobSitesFilter() {
            return this.$store.state.jobSites !== null;
          },
          filteredJobSites() {
            const jobSites =  this.$store.state.jobSites.map(item => {
              return {
                value: item.id,
                label: item.name
              };
            });
            jobSites.unshift({value: '', label: 'All Job Sites'});

            return jobSites;
          },
          isVisibleOvertime() {
            return this.$store.state.companySettings.weekly_overtime || this.$store.state.companySettings.daily_overtime;
          },
          isVisibleDoubleOvertime() {
            return this.$store.state.companySettings.daily_double_overtime;
          }
        },
        mounted() {
            this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
            this.$root.$on('reloadData', this.reloadData);
            this.$root.$on('editTimesheets', this.timesheetEditor);
            this.$root.$on('hideTimesheets', this.hideTimesheetEditor);
            window.scrollTo(0, 0);
        },
        beforeDestroy() {
            this.$root.$off('reloadData');
        },
        methods: {
            getMember() {
                const _this = this;
                if(this.showArchivedMembers){
                    const members = this.$store.state.archivedMembers.filter(item => {
                        return item.uid === _this.$route.params.uid;
                    });
                    if (members.length > 0) {
                        return members[0];
                    }
                }

                const members = this.$store.state.members.filter(item => {
                    return item.uid === _this.$route.params.uid;
                });
                if (members.length > 0) {
                    return members[0];
                }
                return this.$store.state.members[0];
            },
            getTimesheetData: function (from, to) {
                let _this = this;
                this.member = this.getMember();
                this.isLoading = true;
                TimesheetService.getMemberTimesheets(this.member.uid, from, to, this.jobSiteId, this.showArchivedMembers).then((data) => {
                    _this.period = data.period;
                    _this.overview = data.overview;
                    _this.payroll = data.payroll;
                    _this.jobCodes = data.job_codes;
                    _this.entries = data.entries;
                    _this.entry_type = data.entry_type;
                    _this.canManageEntries = data.can_add_entry;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    console.log(error);
                });
            },
            getRouteUrl(item) {
              if(item.entry.id && !item.entry.grouped) {
                return {name: 'TimeEntryDetail', params: {uid: this.member.uid, id: item.entry.id}};
              }
              return {name: 'TimeEntryDaily', params: {uid: this.member.uid, date: item.date}};
            },
            onDateSelected: function (dateRange) {
                //this.clearReportData();
                this.$store.commit('overlay', false);
                const from = this.$moment(dateRange.startDate);
                const to = this.$moment(dateRange.endDate);
                /*if (from.format('MM-DD') === to.format('YYYY-MM-DD')) {
                    this.$router.push({
                        name: 'TimesheetSessions',
                        params: {uid: this.member.uid, date: from.format('YYYY-MM-DD')}
                    });
                    return;
                }*/

                this.$store.commit("period", {
                    from: from.format('YYYY-MM-DD'),
                    to: to.format('YYYY-MM-DD'),
                    fromFormatted: from.format('MMM D'),
                    toFormatted: to.format('MMM D, YYYY')
                });
                this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
            },
            onPeriodEntryClick: function (periodFrom, periodTo) {
                //this.clearReportData();
                this.$store.commit("period", {
                    from: periodFrom,
                    to: periodTo,
                    fromFormatted: this.$moment(periodFrom).format('MMM D'),
                    toFormatted: this.$moment(periodTo).format('MMM D, YYYY')
                });
                this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
            },
            editEntry(e, item) {
                e.preventDefault();

                if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
                    this.$root.$emit('noSubscription');
                    return;
                }
                this.$store.commit('showLoading');
                TimesheetService.getTimeEntryForEdit(item.entry.id).then((data) => {
                    this.$store.commit('hideLoading');
                    console.log(data);
                    this.$root.$emit('showEditEntry', {member: this.member, entry: data});
                }).catch((error) => {
                });
            },
            deleteEntry(e, item) {
                e.preventDefault();
                if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
                    this.$root.$emit('noSubscription');
                    return;
                }

                this.$root.$emit("onDeleteEntry", item.entry);
            },
            hideEditEntries(entry) {
                if (entry !== undefined) {
                    this.$store.commit('showLoading');
                    TimesheetService.getTimeEntryForEdit(entry.id).then((data) => {
                        this.$store.commit('hideLoading');
                        this.$root.$emit('showEditEntry', {member: this.member, entry: data});
                    }).catch((error) => {
                    });
                }
                this.$root.$emit('hideEditEntries');
            },
            reloadData() {
                //this.$root.$emit('hideEditEntry');
                this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
            },
            timesheetEditor() {
                this.timesheetsEditor = true;
            },
            hideTimesheetEditor() {
                this.timesheetsEditor = false;
            },
            onHide() {
                this.popoverShow = false;
            },
            addNewTimeEntry(timesheet = undefined) {
                if (!this.canManageEntries) {
                    return;
                }

                if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
                    this.$root.$emit('noSubscription');
                    return;
                }
                let date = undefined;
                if (timesheet !== undefined) {
                    date = timesheet.date;
                }
                this.$root.$emit('showCreateEntry', { member: this.member, selectedDate: date });
            },
            clearReportData() {
                this.report = {
                    total_time: '',
                    regular_time: '',
                    overtime: '',
                    breaks: '',
                    pto: '',
                    jobs: []
                };
                this.timesheets = [];
            },
            onJobSiteSelected(selected){
              this.jobSiteId = selected.value;
              this.getTimesheetData(this.$store.state.period.from, this.$store.state.period.to);
            },
        }
    }
</script>


<style lang="scss">
.manual-entries-wrapper{
  display: flex;
  position: absolute;
  margin-left: 214px;
}
  .filter-job-sites{
    .b-dropdown {

      .dropdown-toggle {
        display: inline-flex;
        align-items: center;
        background-color: $atto-white;
        border: 2px solid $atto-light-grey;
        padding: 12px 8px 12px 12px;
        width: 200px;
        height: 48px;
        position: relative;
        margin-left: 16px;
        cursor: pointer;
        border-radius: 0;
        @include base-transition(ease all 0.15s);

        span.filter-title {
          color: $atto-not-active;
          font-family: $roboto-font;
          font-weight: $roboto-medium;
          font-size: 0.875rem;
          line-height: 1.2rem;
        }

        &:hover {
          text-decoration: none;
          border-color: $grey-nuance-darker;
        }

        &:focus,
        &:active,
        &:active:focus {
          text-decoration: none;
        }
      }

      .dropdown-menu {
        border: 0;
        position: absolute;
        top: -8px;
        left: 0;
        width: 200px;
        box-shadow: 0 0 10px 0 rgba(38, 38, 38, 0.15);
        background-color: $atto-white;
        border-radius: 0;
        padding: 0 0 8px 0;
        margin: -48px 0 0 1px;

        li.disabled {
          a {
            display: flex;
            flex-direction: row;
            padding: 12px 8px 12px 12px;
            align-items: center;
            border-bottom: 2px solid $atto-light-grey;
            margin-bottom: 8px;

            p {
              flex-grow: 1;
              margin-bottom: 0;
              font-size: 0.875rem;
              line-height: 1.5rem;
              font-family: $roboto-font;
              color: $atto-font-color;
              font-weight: $roboto-medium;
            }

            &:hover {
              background-color: transparent;
            }
          }

        }

        li {
          display: flex;
          padding: 0;

          a {
            padding: 12px 8px 12px 12px;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-family: $roboto-font;
            color: $atto-font-color;
            font-weight: $roboto-medium;
            width: 100%;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
              background-color: #F7F7F7;
            }
          }
        }
      }

      i.atto-u-arrow-b,
      i.atto-d-arrow-b {
        font-size: 12px;
        color: #c9c9c9;
        margin-left: auto;
        margin-right: 8px;
      }

      i.atto-d-arrow-b {
        margin-right: 7px;
      }

    }
  }
 /* .customize-log{
    hr{
      display: inline-flex;
      height: 12px;
      width: 1px;
      background-color: #e3e3e3;
      margin: 0 8px;
    }
  }*/
  .delete-tooltip{
    .tooltip-inner{
      background-color: $atto-red !important;
      width: 64px;
      height: 36px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $atto-white;
      font-size: 0.875rem;
      line-height: 1rem;
      font-weight: $roboto-medium;
    }
   .arrow{
     &:before{
       border-top-color: $atto-red !important;
       border-bottom-color: $atto-red !important;
     }
   }
  }
  .edit-tooltip{
    .tooltip-inner{
      background-color: $atto-font-color !important;
      width: 64px;
      height: 36px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $atto-white;
      font-size: 0.875rem;
      line-height: 1rem;
      font-weight: $roboto-medium;
    }
    .arrow{
      &:before{
        border-top-color: $atto-font-color !important;
        border-bottom-color: $atto-font-color !important;
      }
    }
  }
</style>

<style lang="scss" scoped>

  .content-header h3{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 260px;
  }

  .license{
    color: #666666;
    font: 500 14px/28px "Roboto", sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 260px;
  }

  .right-block{
    display: flex;
    flex-flow: row;

    .filter-job-sites{

      .atto-select{
        height: 48px;
        width: 174px;
      }
    }
    .date-picker{
      margin-left: 16px;
    }
  }

  .white-card{
   /* min-height: 268px;*/
    height: 100%;

    .table-header{
      background-color: #FAFAFA;
      padding: 12px 0 12px 20px;
      height: 35px;
      align-items: center;


      justify-content: space-between;
      span{
        &.column-header{
          color: #666666;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          font-size: 0.625rem;
          line-height: 0.6875rem;
          font-weight: $roboto-medium;
          /*width: 15%;*/
          margin-right: 0;
          padding-right: 10px;
          /*min-width: 85px;*/
          width: 85px;
        }
        &.name{
          /*width: 35%;
          min-width: 190px;*/
          width: 160px;
        }
        &.date{
          min-height: 0;
          width: 27px;
          min-width: 27px;
          margin-right: 25px;
        }
      }
      .first-column{
        display: flex;
        align-items: center;
        width: 210px;
        margin-right: 30px;
      }
      .second-column{
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .logs-list{
    li{
      .day-log{
        /*width: 23.1%;
        min-width: 243px;
        margin-right: 0;
        padding-right: 12px;*/
        div.calendar-icon{
          border-right: 1px solid $atto-light-grey;
          border-left: 1px solid $atto-light-grey;
          border-radius: 0;
          border-top: none;
          border-bottom: none;
          height: 24px;
          margin-right: 12px;

          .day{
            color: $atto-green;
            border: none;
            font-size: 0.75rem;
            line-height: 0.875rem;
            background-color: transparent;
          }
          .date{
            color: #666666;
            line-height: 0.6875rem;
          }
        }
        .time-interval{
          span.end-time{
            font-weight: $roboto-regular;
          }
          span.start-time{
            font-weight: $roboto-regular;
          }
          span.pto {
            line-height: 1rem;
          }
        }
      }
      .hour-total {
        max-width: 100%;
        flex-grow: unset;
        width: 100%;
        justify-content: space-between;
        display: flex;
        .hours{
          width: 85px;
        /*  width: 15%;
          min-width: 85px;*/
        }
      }
      .customize-log{
        position: absolute;
        z-index: 9999;
        background-color: #FAFAFA;
        /*width: auto;*/
        margin: 0;
        min-width: 130px;
        padding-left: 20px;
        right: 32px;
        display: inline-flex;
        align-items: center;
        .edit-log{
          i{
            &:before{
              color: $atto-font-color;
            }
          }
          &:hover{
            i{
              &:before{
                color: $atto-font-color;
              }
            }
          }
        }
        .delete-log{
          i{
            &:before{
              color: $atto-font-color;
            }
          }
         &:hover{
           i{
             &:before{
               color: $atto-red;
             }
           }
         }
        }
      }
      &:hover{
        background-color: #FAFAFA;
      }
    }
    &.days{
      li{
        padding: 13px 0 13px 20px;
        height: 50px;
        &.no-entry{
          .no-entries{
            .day-log{
            /*  width: 23.1%;
              min-width: 243px;
              margin-right: 0;
              padding-right: 12px;*/
              width: 212px;
              margin-right: 30px;
              min-width: 212px;

              div.calendar-icon{
                border-right: 1px solid $atto-light-grey;
                border-left: 1px solid $atto-light-grey;
                border-radius: 0;
                border-top: none;
                border-bottom: none;
                height: 24px;
                margin-right: 12px;

                .day{
                  color: $atto-green;
                  border: none;
                  font-size: 0.75rem;
                  line-height: 0.875rem;
                  background-color: transparent;
                }
                .date{
                  color: #666666;
                  line-height: 0.6875rem;
                }
              }
              .time-interval{
                span.end-time{
                  font-weight: $roboto-regular;
                }
                span.start-time{
                  font-weight: $roboto-regular;
                  margin-right: 9px;
                }
                .not-active{
                  color: $atto-font-color;
                  font-weight: $roboto-regular;
                }
                .add-new-entry{
                  display: none;
                }
              }
            }
          }
        }
        &:hover{
          .not-active.can-add{
            display: none;
          }
          .add-new-entry{
            display: flex !important;
            font: $roboto-medium 14px/24px $roboto-font;
            i{
              color: $atto-green;
              font-size: 20px;
              margin-right: 8px;
            }
          }
        }
      }
    }
    &.weeks{
      .first-column{
        width: 210px;
        margin-right: 30px;
        min-width: 210px;
        display: flex;
      }
    }
  }

  .content-list{
    overflow-x: auto;
    width: 100%;

    .table-header{
      width: 100%;
      min-width: 1031px;
    }
    .table-content{
      width: 100%;
      display: flex;
      min-width: 1031px;

      &.archived-member{
        .logs-list.days{
          li{
            &:hover {
              cursor: default;
              .not-active{
                display: flex;
              }
            }
          }
        }
      }
    }
  }
  ul{
    &.day-and-weeks {
      .week-wrapper {
        .week-heading{
          display: flex;
          align-items: center;
          justify-content: space-between;

          .date-interval{
           /* width: 19.6%;
            min-width: 190px;*/
          }
          .hour-total{
            display: flex;
            justify-content: space-between;
            .hours{
              width: 85px;
             /* width: 12%;
              min-width: 85px;*/
            }
          }
        }
        .days-log {
          li {
            &.no-entry{
              .no-entries{
                .day-log{
                  /*width: 22.6%;
                  min-width: 236px;*/
                }
              }
            }
            .day-log{
               width: 212px;
                margin-right: 30px;

              .time-interval{
                min-width: 170px;
              }
            }
          }
        }
      }
      .first-column{
        width: 210px;
        margin-right: 30px;
        min-width: 210px;
        display: flex;
      }
    }
  }

</style>